<template>
    <div>
        <Dialog v-model:visible="visible" :style="{ width: '40vw' }" header="Send Notification" :modal="true" class="p-fluid dialog-header" @hide="emit('hide-dialog', true)">
            <div class="field">
                <base-text-input v-model="notification.subject" label="Subject" :error-message="formErrors.subject" :autofocus="true" />
            </div>
            <div class="field">
                <label for="name">Message:</label>
                <Textarea id="name" type="text" :class="{ 'p-invalid': formErrors.message }" v-model="notification.message" rows="5" autofocus />
                <small class="p-invalid" v-if="formErrors.message">Message is required</small>
            </div>
            <template #footer>
                <Button label="Cancel" icon="pi pi-times" class="p-button-danger" @click="visible = false" />
                <Button label="Submit" icon="pi pi-check" :loading="buttonLoading" @click="send()" />
            </template>
        </Dialog>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { ref, computed, defineEmits, onUnmounted, defineProps } from 'vue';
import { object, string } from 'yup';
import BaseTextInput from '../../../../../modules/custom-inputs/BaseTextInput.vue';
import { taskStore, formErrorStore } from '../../../../../store/global-stores';
import { showToast } from '../../../../../utilities/toast-handler';
import { handleValidationErrors } from '../../../../../utilities/form-errors-handler';
const { formErrors } = storeToRefs(formErrorStore);
const { notification } = storeToRefs(taskStore);
const visible = ref(true);
const buttonLoading = ref(false);
const emit = defineEmits(['hide-dialog']);

const props = defineProps({
    taskIds: {
        type: Array,
    },
});

onUnmounted(() => {
    taskStore.initNotification();
});

const taskIds = computed(() => {
    return props.taskIds?.map((task) => task.id);
});

// validation schemas
const validationSchema = object({
    subject: string().required('Subject required.'),
    message: string().required('Message required.'),
});

const send = async () => {
    try {
        notification.value.tasks = taskIds.value;

        await validationSchema.validate({ ...notification.value }, { abortEarly: false });
        formErrorStore.clearErrors();
        const res = await taskStore.sendNotification();
        if (res) {
            emit('hide-dialog', true);
        }
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            const errors = handleValidationErrors(error);
            formErrorStore.addErrors(errors);
            showToast({}, 'Input data invalid');
        }
    }
};
</script>
